import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';
import {AuthGuard} from './auth-gaurd.service';
import {BasicInfoComponent} from './basic-info/basic-info.component';
import {LandingPageComponent} from "./landing-page/landing-page.component";

export const router: Routes = [
  { path: '', redirectTo: 'landing-page', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'volunteer-form', component: BasicInfoComponent, canActivate: [AuthGuard] },
  { path: 'landing-page', component: LandingPageComponent },

]

export const routes: ModuleWithProviders = RouterModule.forRoot(router);



// WEBPACK FOOTER //
// D:/Projects/angular/ecell-hcst/src/app/app.routes.ts